/* eslint-disable */
// FIXME: https://jira.icims.net/browse/TXTE-27869
// import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import App from './App';
import config from 'config';
// import * as serviceWorker from './serviceWorker';

const renderApp = async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: config.launchDarklyId,
  });
  const container = document.getElementById('root');
  const root = createRoot(container);
  root.render(
    <LDProvider>
      {/* <StrictMode> */}
      <App />
      {/* </StrictMode> */}
    </LDProvider>,
  );
};

/* eslint-disable no-process-env, no-underscore-dangle */
if (process.env.NODE_ENV !== 'production' && module.hot) {
  module.hot.accept('./App', renderApp);
}

renderApp();

/**
 * FIXME: cloudEnv is deprecated and we should use an alternative method for detecting env. -Amir
 * This is to improve developer experience when switching environments during testing.
 * If the environment in localStorage does not match the env app is currently running
 * we will clear the entire web-app's data from localStorage to prevent
 * mismatched environment tokens.
 */
// if (config.envShortName !== appEnv.PRODUCTION) {
// 	const storedEnv = windowStore.get(cacheKey.CLOUD_ENV);
// 	if (storedEnv && !storedEnv.includes(config.envShortName)) {
// 		windowStore.clear();
// 	}
// }

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// TODO: we need serviceWorker that is customizable -Amir
// serviceWorker.unregister();
// serviceWorker.register();
